export default {
  route: {
    dashboard: 'Επισκόπηση',
    UpcomingMeetings: 'Προσεχείς συναντήσεις',
    ReadMore: 'Δείτε Περισσότερα',
    Client: 'Πελάτης',
    Date: 'Ημ/νία',
    Location: 'Περιοχή',
    Time: 'Ώρα',
    Manager: 'Διαχειριστής',
    Deadline: 'Προθεσμία',
    Delivery: 'Παράδοση',
    Cost: 'Κόστος',
    Days: ' Μέρες',
    Of: 'Από',
    Remaining: 'Απομένουν',
    NeedHelp: 'Χρειάζεσαι Βοήθεια',
    Completed: 'Ολοκληρώθηκε',
    Pending: 'Εν Αναμονή',
    InProgress: 'Σε Εξέλιξη',
    NotStarted: 'Δεν έχει Ξεκινήσει',
    Assignee: 'Υπεύθυνος',
    RunningTasks: 'Τρέχουσες Εργασίες',
    Archive: 'Αρχείο',
    DeleteNotification:
      'Πρόκειτε να σβήσετε την εργασία διαπαντώς, θέλετε να συνεχίσετε ;',
    Yes: 'Ναι',
    No: 'Όχι',
    DeleteCompleted: 'Η Διαγραφή Ολοκληρώθηκε',
    DeleteCanceled: 'Η Διαγραφή Ακυρώθηκε',
    Warning: 'Προσοχή',
    AssignTo: 'Ανάθεση σε',
    taskName: 'Τίτλος Εργασίας',
    SaveTask: 'Καταχώρηση Εργασίας',
    InputTaskName: 'Παρακαλώ εισάγετε τίτλο εργασίας',
    FormMinLength: 'Ελάχιστο μέγεθος 3 χαρακτήρες',
    FormAddAssignee: 'Παρακαλώ επιλέξτε Υπεύθυνο',
    Meeting: 'Κανένα Ραντεβού',
    noFiles: 'Δεν υπάρχουν αρχεία',
    Months: 'Μήνες',
    Month: 'Μήνας',
    PendingTickers: 'Εκκρεμή Tickets',
    LatestOrders: 'Tελευταίες Παραγγελίες',
    NoData: 'Χωρίς Δεδομένα',
    ArchiveTask:
      'Πρόκειτε να αρχειοθετήσετε την εργασία, Θέλετε να συνεχίσετε ;',
    ArchiveCompleted: 'Η αρχειοθέτηση ολοκληρώθηκε',
    ArchiveCanceled: 'Η αρχειοθέτηση ακυρώθηκε',
    AllActivity: 'Όλη η δραστηριότητα',
    CommunicationLog: 'Λίστα επικοινωνίας',
    Transactions: 'Συναλλαγές',
    SystemLog: 'Μητρώο συστήματος',
    Outstanding: 'Εκκρεμή',
    Paid: 'Πληρωμένα',
    Files: 'Αρχεία',
    Upload: 'Μεταφόρτωση',
    SelectUser: 'Επιλέξτε χρήστη',
    LogOut: 'Αποσύνδεση'
  },
  tips: {
    LatestOrdersTxt:
      'Εδώ είναι η λίστα με τις παραγγελίες των τελευταίων 30 ημερών',
    PendingTicketsTxt:
      'Εδώ μπορείτε να δείτε την λίστα με τα Tickets που είναι σε εκκρεμότητα (δεν έχουν ακόμη επιλυθεί)',
    OutstandingTxt:
      'Εδώ μπορείτε να δείτε την λίστα με τα εκκρεμή τιμολόγια. Σε περίπτωση που οι συλλογές δεν σχετίζονται άμεσα με συγκεκριμένα τιμολόγια, μπορεί να υπάρχουν τιμολόγια  που έχουν καταβληθεί αλλά εμφανίζοντε ως εκκρεμή.',
    TasksTxt:
      'Μπορείτε να μεταφέρετε τις παρακάτω εργασίες ώστε να αλλάξετε την προταιρεότητα. Οι ολοκληρωμένες εργασίες μπορούν να αρχειοθετηθούν και να μετακινηθούν στην αντίστοιχη καρτέλα',
    TasksArchTxt:
      'Εδώ μπορείτε να βρείτε όλες τις ολοκληρωμένες ή αρχειοθετημένες εργασίες.'
  },
  tables: {
    Task: 'Εργασία',
    Project: 'Έργο',
    Assignee: 'Υπεύθυνος',
    Complete: 'Ολοκληρώθηκε',
    Items: 'Προϊόντα',
    TotalAmount: 'Συνολικό ποσό',
    InsertedBy: 'Καταχωρήθηκε από',
    LastStatus: 'Κατάσταση',
    Description: 'Περιγραφή',
    Priority: 'Προτεραιότητα',
    TicketType: 'Είδος Ticket',
    From: 'Από',
    To: 'Προς',
    Resolved: 'Επιλύθηκε',
    FullName: 'Όνομ/μο',
    Channel: 'Κανάλι',
    Avatar: 'Άβαταρ',
    Filename: 'Όνομα Αρχείου',
    DateAdded: 'Ήμ/νια Προσθήκης',
    Actions: 'Ενέργειες',
    Transactiontype: 'Τύπος Συναλλαγής',
    LocationIp: 'Τοποθεσία / Ip',
    DaysAgo: 'Μέρες πριν'
  },
  transactionsType: {
    Buy: 'Buy',
    Purchases: 'Αγορές',
    Sales: 'Πωλήσεις',
    CollectionsPayments: 'Εισπράξεις-Πληρωμές',
    Expenses: 'Δαπάνες',
    Services: 'Παροχή Υπηρεσιών',
    Inventory: 'Ενδοδιακίνησης',
    PurchasesOrders: 'Παραγγελίες Αγοράς',
    ExpensesOrders: 'Παραγγελίες Δαπανών',
    SalesOffers: 'Προσφορά Πώλησης',
    SalesOrder: 'Παραγγελία πώλησης',
    ServicesOffers: 'Προσφορά υπηρεσιών',
    ServicesOrders: 'Παραγγελία υπηρεσιών',
    ThirdPartyItems: 'Είδη τρίτων',
    ItemsToOthers: 'Είδη σε τρίτους',
    BulkMovementsOfSecurities: 'Μαζικές κινήσεις αξιόγραφων'
  }
};



// WEBPACK FOOTER //
// ./src/lang/gr.js